module.exports = __webpack_public_path__ + "static/media/yellow-30.8842ecdd.png";